import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnDestroy,
  OnChanges
} from '@angular/core';
import { User } from 'ngx-login-client';


export class SwitchComponent {
   isChecked: Boolean;
   onChecked = new EventEmitter();

  toggleSwitch(event) {
    this.onChecked.emit(event);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isChecked': [{ type: Input },],
'onChecked': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
